// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.__level_widget {
  background-color: #090909;
  border-radius: 5px;
  padding: 16px;
}
.__level_widget:hover {
  background-color: #1a1a1a;
}`, "",{"version":3,"sources":["webpack://./src/components/LevelCard/index.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,kBAAA;EACA,aAAA;AACF;AAAE;EACE,yBAAA;AAEJ","sourcesContent":[".__level_widget {\n  background-color: #090909;\n  border-radius: 5px;\n  padding: 16px;\n  &:hover {\n    background-color: #1a1a1a;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
